import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

import Login from '../views/Login.vue'
import Chat from '../views/Chat.vue'
import AdminDashboard from '../views/admin/Dashboard.vue'
import AdminTest from '../views/admin/Test.vue'
import {
  AdminTileList,
  AdminTileAdd,
  AdminTileShow,
  AdminTileEdit
} from '@/views/admin/tiles'
import {
  AdminGroupList,
  AdminGroupAdd,
  AdminGroupShow,
  AdminGroupEdit
} from '@/views/admin/groups'
import {
  AdminProjectList,
  AdminProjectAdd,
  AdminProjectShow,
  AdminProjectResults,
  AdminProjectEdit
} from '@/views/admin/projects'
import {
  AdminArchetypesList,
  AdminArchetypesAdd,
  AdminArchetypesShow,
  AdminArchetypesEdit
} from '@/views/admin/archetypes'
import {
  AdminKeywordsList,
  AdminKeywordsAdd,
  AdminKeywordsShow,
  AdminKeywordsEdit
} from '@/views/admin/keywords'
import {
  AdminExerciseList,
  AdminExerciseAdd,
  AdminExerciseShow,
  AdminExerciseEdit
} from '@/views/admin/exercises'
import {
  AdminFunctionalityList,
  AdminFunctionalityAdd,
  AdminFunctionalityShow,
  AdminFunctionalityEdit
} from '@/views/admin/functionality'
import {
  AdminBenchmarkList,
  AdminBenchmarkAdd,
  AdminBenchmarkShow,
  AdminBenchmarkEdit
} from '@/views/admin/benchmarks'
import {
  AdminPictosList,
  AdminPictosAdd,
  AdminPictosShow,
  AdminPictosEdit
} from '@/views/admin/pictos'
import {
  AdminPlanesList,
  AdminPlanesAdd,
  AdminPlanesShow,
  AdminPlanesEdit
} from '@/views/admin/planes'
import {
  AdminTravelList,
  AdminTravelAdd,
  AdminTravelShow,
  AdminTravelEdit
} from '@/views/admin/travel'
import { PictosAdd, PictosEdit } from '@/views/user/exercises/pictos'
import {
  AdminUserList,
  AdminUserAdd,
  AdminUserShow,
  AdminUserEdit
} from '@/views/admin/users'

import UserDashboard from '../views/user/Dashboard.vue'
import UserReset from '../views/user/Reset.vue'
import UserBrandTiles from '../views/user/exercises/UserBrandTiles.vue'
import UserBrandTilesSurvey from '../views/user/exercises/UserBrandTilesSurvey.vue'
import UserBrandTilesSurveyHaringey from '../views/user/exercises/UserBrandTilesSurveyHaringey.vue'
import UserBrandTilesSurveyIncipio from '../views/user/exercises/UserBrandTilesSurveyIncipio.vue'
import UserBrandTilesMultiple from '../views/user/exercises/UserBrandTilesMultiple.vue'
import UserFunctionality from '../views/user/exercises/UserFunctionality3.vue'
import UserTov from '../views/user/exercises/UserTov.vue'
import UserArchetypes from '../views/user/exercises/UserArchetypes.vue'
import UserKeywords from '../views/user/exercises/UserKeywords.vue'
import UserService from '../views/user/exercises/UserService.vue'
import UserServiceUser from '../views/user/exercises/UserServiceUser.vue'
import UserProposition from '../views/user/exercises/UserProposition2.vue'
import UserPictos from '../views/user/exercises/UserPictos.vue'
import UserArchitectureId from '../views/user/exercises/UserArchitectureId.vue'
import UserArchitectureMenu from '../views/user/exercises/UserArchitectureMenu.vue'
import UserStructure from '../views/user/exercises/UserStructure.vue'
import UserMessage from '../views/user/exercises/UserMessage.vue'
import UserPersonas from '../views/user/exercises/UserPersonas.vue'
import UserPersonasMenu from '../views/user/exercises/UserPersonasMenu.vue'
import UserGroups from '../views/user/exercises/UserGroups.vue'
// import UserGroupsSimple from "../views/user/exercises/UserGroupsSimple.vue";
import UserGroupsMenu from '../views/user/exercises/UserGroupsMenu.vue'
import UserFly from '../views/user/exercises/UserFly2.vue'
import UserTravel from '../views/user/exercises/UserTravel.vue'
import UserSwot from '../views/user/exercises/UserSwot.vue'
import UserActivation from '../views/user/exercises/UserActivation.vue'
import UserTraffic from '../views/user/exercises/UserTraffic.vue'
import UserBlock from '../views/user/exercises/UserBlock.vue'
import UserEmpathy from '../views/user/exercises/UserEmpathy.vue'
import UserProblem from '../views/user/exercises/UserProblem.vue'
import UserIsInIf from '../views/user/exercises/UserIsInIf.vue'
import UserProject from '../views/user/UserProject.vue'
import UserResults from '../views/user/UserResults.vue'
import UserPriority from '../views/user/exercises/UserPriority.vue'
import UserQuadrants from '../views/user/exercises/UserQuadrants.vue'
import UserStakeholder from '../views/user/exercises/UserStakeholder.vue'
import UserStakeholderStandard from '../views/user/exercises/UserStakeholderStandard.vue'
import UserSuccess from '../views/user/exercises/UserSuccess.vue'
import UserSuccessPillars from '../views/user/exercises/UserSuccessPillars.vue'
import UserChallengePillars from '../views/user/exercises/UserChallengePillars.vue'
import UserAttributes from '../views/user/exercises/UserAttributes.vue'
import UserBenefits from '../views/user/exercises/UserBenefits.vue'
import UserTimeline from '../views/user/exercises/UserTimeline.vue'
import UserBrandArchitecture from '../views/user/exercises/UserBrandArchitecture.vue'
import UserCompetition from '../views/user/exercises/UserCompetition.vue'
import UserCompetitionMatrix from '../views/user/exercises/UserCompetitionMatrix.vue'
import UserCompetitionMatrixPart2 from '../views/user/exercises/UserCompetitionMatrixPart2.vue'
import UserDeliverables from '../views/user/exercises/UserDeliverables.vue'
import UserDeliverablesCategorised from '../views/user/exercises/UserDeliverablesCategorised.vue'
import UserDeliverablesAmbassadors from '../views/user/exercises/UserDeliverablesAmbassadors.vue'
import UserDeliverablesMenu from '../views/user/exercises/UserDeliverablesMenu.vue'
import UserFourCornersMenu from '../views/user/exercises/UserFourCornersMenu.vue'
import UserFourCornersContext from '../views/user/exercises/UserFourCornersContext.vue'
import UserFourCornersCompetition from '../views/user/exercises/UserFourCornersCompetition.vue'
import UserFourCornersClient from '../views/user/exercises/UserFourCornersClient.vue'
import UserFourCornersCustomer from '../views/user/exercises/UserFourCornersCustomer.vue'
import UserTodayTomorrow from '../views/user/exercises/UserTodayTomorrow.vue'

import UserSayDo from '../views/user/exercises/UserSayDo.vue'
// import UserNameArchitectureId from "../views/user/exercises/UserNameArchitectureId.vue";
// import UserNameArchitectureMenu from "../views/user/exercises/UserNameArchitectureMenu.vue";
import UserEcoSystemId from '../views/user/exercises/UserEcoSystemId.vue'
import UserEcoSystemMenu from '../views/user/exercises/UserEcoSystemMenu.vue'
import UserMappingId from '../views/user/exercises/UserMappingId.vue'
import UserMappingMenu from '../views/user/exercises/UserMappingMenu.vue'

import UserCultureMenu from '../views/user/exercises/UserCultureMenu.vue'
import UserCultureLanguage from '../views/user/exercises/UserCultureLanguage.vue'
import UserCultureBehaviour from '../views/user/exercises/UserCultureBehaviour.vue'
import UserCultureKnowledge from '../views/user/exercises/UserCultureKnowledge.vue'
import UserCultureDynamics from '../views/user/exercises/UserCultureDynamics.vue'

import UserAudienceSystemId from '../views/user/exercises/UserAudienceSystemId.vue'
import UserAudienceSystemMenu from '../views/user/exercises/UserAudienceSystemMenu.vue'

import UserOfferSystemId from '../views/user/exercises/UserOfferSystemId.vue'
import UserOfferSystemMenu from '../views/user/exercises/UserOfferSystemMenu.vue'

import UserOfferSystemMenuTabs from '../views/user/exercises/UserOfferSystemMenuTabs.vue'
import UserOfferSystemIdTabs from '../views/user/exercises/UserOfferSystemIdTabs.vue'
import UserOfferSystemFacilitatedMenu from '../views/user/exercises/UserOfferSystemFacilitatedMenu.vue'
import UserOfferSystemFacilitated from '../views/user/exercises/UserOfferSystemFacilitated.vue'

import UserRollOutId from '../views/user/exercises/UserRollOutId.vue'
import UserRollOutMenu from '../views/user/exercises/UserRollOutMenu.vue'

import UserChallengesSystemId from '../views/user/exercises/UserChallengesSystemId.vue'
import UserChallengesSystemMenu from '../views/user/exercises/UserChallengesSystemMenu.vue'

import UserNameSystemId from '../views/user/exercises/UserNameSystemId.vue'
import UserNameSystemMenu from '../views/user/exercises/UserNameSystemMenu.vue'

import UserLogicSystemId from '../views/user/exercises/UserLogicSystemId.vue'
import UserLogicSystemMenu from '../views/user/exercises/UserLogicSystemMenu.vue'
import UserMuseum from '../views/user/exercises/UserMuseum.vue'

Vue.use(Router)

const routes = [
  {
    path: '*',
    redirect: '/login'
  },
  {
    path: '/chat',
    name: 'Chat',
    component: Chat
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/admin/dashboard',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin/test',
    name: 'AdminTest',
    component: AdminTest,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/admin/tiles',
    name: 'AdminTileList',
    component: AdminTileList,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'edit/:id',
        name: 'AdminTileEdit',
        component: AdminTileEdit,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'show/:id',
        name: 'AdminTileShow',
        component: AdminTileShow,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'add',
        name: 'AdminTileAdd',
        component: AdminTileAdd
      }
    ]
  },
  {
    path: '/admin/groups',
    name: 'AdminGroupList',
    component: AdminGroupList,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'edit/:id',
        name: 'AdminGroupEdit',
        component: AdminGroupEdit,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'show/:id',
        name: 'AdminGroupShow',
        component: AdminGroupShow,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'add',
        name: 'AdminGroupAdd',
        component: AdminGroupAdd
      }
    ]
  },
  {
    path: '/admin/exercises',
    name: 'AdminExerciseList',
    component: AdminExerciseList,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'edit/:id',
        name: 'AdminExerciseEdit',
        component: AdminExerciseEdit,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'show/:id',
        name: 'AdminExerciseShow',
        component: AdminExerciseShow,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'add',
        name: 'AdminExerciseAdd',
        component: AdminExerciseAdd
      }
    ]
  },
  {
    path: '/admin/functionality',
    name: 'AdminFunctionalityList',
    component: AdminFunctionalityList,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'edit/:id',
        name: 'AdminFunctionalityEdit',
        component: AdminFunctionalityEdit,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'show/:id',
        name: 'AdminFunctionalityShow',
        component: AdminFunctionalityShow,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'add',
        name: 'AdminFunctionalityAdd',
        component: AdminFunctionalityAdd
      }
    ]
  },
  {
    path: '/admin/archetypes',
    name: 'AdminArchetypesList',
    component: AdminArchetypesList,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'edit/:id',
        name: 'AdminArchetypesEdit',
        component: AdminArchetypesEdit,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'show/:id',
        name: 'AdminArchetypesShow',
        component: AdminArchetypesShow,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'add',
        name: 'AdminArchetypesAdd',
        component: AdminArchetypesAdd
      }
    ]
  },
  {
    path: '/admin/keywords',
    name: 'AdminKeywordsList',
    component: AdminKeywordsList,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'edit/:id',
        name: 'AdminKeywordsEdit',
        component: AdminKeywordsEdit,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'show/:id',
        name: 'AdminKeywordsShow',
        component: AdminKeywordsShow,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'add',
        name: 'AdminKeywordsAdd',
        component: AdminKeywordsAdd
      }
    ]
  },
  {
    path: '/admin/projects',
    name: 'AdminProjectList',
    component: AdminProjectList,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'edit/:id',
        name: 'AdminProjectEdit',
        component: AdminProjectEdit,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'show/:id',
        name: 'AdminProjectShow',
        component: AdminProjectShow,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'results/:id',
        name: 'AdminProjectResults',
        component: AdminProjectResults,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'add',
        name: 'AdminProjectAdd',
        component: AdminProjectAdd
      }
    ]
  },
  {
    path: '/admin/tov',
    name: 'AdminBenchmarkList',
    component: AdminBenchmarkList,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'edit/:id',
        name: 'AdminBenchmarkEdit',
        component: AdminBenchmarkEdit,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'show/:id',
        name: 'AdminBenchmarkShow',
        component: AdminBenchmarkShow,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'add',
        name: 'AdminBenchmarkAdd',
        component: AdminBenchmarkAdd
      }
    ]
  },
  {
    path: '/admin/pictos',
    name: 'AdminPictosList',
    component: AdminPictosList,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'edit/:id',
        name: 'AdminPictosEdit',
        component: AdminPictosEdit,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'show/:id',
        name: 'AdminPictosShow',
        component: AdminPictosShow,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'add',
        name: 'AdminPictosAdd',
        component: AdminPictosAdd
      }
    ]
  },
  {
    path: '/admin/fly',
    name: 'AdminPlanesList',
    component: AdminPlanesList,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'edit/:id',
        name: 'AdminPlanesEdit',
        component: AdminPlanesEdit,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'show/:id',
        name: 'AdminPlanesShow',
        component: AdminPlanesShow,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'add',
        name: 'AdminPlanesAdd',
        component: AdminPlanesAdd
      }
    ]
  },
  {
    path: '/admin/travel',
    name: 'AdminTravelList',
    component: AdminTravelList,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'edit/:id',
        name: 'AdminTravelEdit',
        component: AdminTravelEdit,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'show/:id',
        name: 'AdminTravelShow',
        component: AdminTravelShow,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'add',
        name: 'AdminTravelAdd',
        component: AdminTravelAdd
      }
    ]
  },
  {
    path: '/admin/users',
    name: 'AdminUserList',
    component: AdminUserList,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'edit/:id',
        name: 'AdminUserEdit',
        component: AdminUserEdit,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'show/:id',
        name: 'AdminUserShow',
        component: AdminUserShow,
        props: route => ({ id: route.params.id })
      },
      {
        path: 'add',
        name: 'AdminUserAdd',
        component: AdminUserAdd
      }
    ]
  },
  {
    path: '/users/dashboard',
    name: 'UserDashboard',
    component: UserDashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/users/reset',
    name: 'UserReset',
    component: UserReset,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/users/project/:id',
    name: 'UserProject',
    component: UserProject,
    props: route => ({ id: route.params.id }),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'tiles',
        name: 'UserBrandTiles',
        component: UserBrandTiles,
        meta: {
          requiresAuth: true,
          content: 'exercise_tiles',
          model: 'tilesExCollection'
        }
      },
      {
        path: 'tiles-extended',
        name: 'UserBrandTilesExtended',
        component: UserBrandTiles,
        meta: {
          requiresAuth: true,
          content: 'exercise_tiles',
          model: 'tilesExCollectionExtended'
        }
      },

      {
        path: 'tiles-survey',
        name: 'UserBrandTilesSurvey',
        component: UserBrandTilesSurvey,
        meta: {
          requiresAuth: true,
          content: 'exercise_tiles_survey',
          model: 'tilesExCollectionSurvey'
        }
      },
      {
        path: 'tiles-survey-haringey',
        name: 'UserBrandTilesSurveyHaringey',
        component: UserBrandTilesSurveyHaringey,
        meta: {
          requiresAuth: true,
          content: 'exercise_tiles_survey',
          model: 'tilesExCollectionSurvey'
        }
      },
      {
        path: 'tiles-survey-incipio',
        name: 'UserBrandTilesSurveyIncipio',
        component: UserBrandTilesSurveyIncipio,
        meta: {
          requiresAuth: true,
          content: 'exercise_tiles_survey',
          model: 'tilesExCollectionSurvey'
        }
      },
      {
        path: 'tiles-future',
        name: 'UserBrandTilesFuture',
        component: UserBrandTiles,
        meta: {
          requiresAuth: true,
          content: 'exercise_tiles_future',
          model: 'tilesFutureExCollection'
        }
      },
      {
        path: 'tiles-multiple',
        name: 'UserBrandTilesMultiple',
        component: UserBrandTilesMultiple,
        meta: {
          requiresAuth: true,
          content: 'exercise_tiles_multiple',
          model: 'tilesMultipleExCollection'
        }
      },
      {
        path: 'functionality',
        name: 'UserFunctionality',
        component: UserFunctionality,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'tov',
        name: 'UserTov',
        component: UserTov,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'archetypes',
        name: 'UserArchetypes',
        component: UserArchetypes,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'keywords',
        name: 'UserKeywords',
        component: UserKeywords,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'architecture',
        name: 'UserArchitectureMenu',
        component: UserArchitectureMenu,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'architecture/:eid',
        name: 'UserArchitectureId',
        component: UserArchitectureId,
        props: route => ({ eid: route.params.eid }),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'architecture/create',
        name: 'UserArchitectureNew',
        component: UserArchitectureId,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'saydo',
        name: 'UserSayDo',
        component: UserSayDo,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'tomorrow',
        name: 'UserTodayTomorrow',
        component: UserTodayTomorrow,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'four-corners',
        name: 'UserFourCornersMenu',
        component: UserFourCornersMenu,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'four-corners/context/:eid',
        name: 'UserFourCornersContext',
        component: UserFourCornersContext,
        props: route => ({ eid: route.params.eid }),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'four-corners/customer/:eid',
        name: 'UserFourCornersCustomer',
        component: UserFourCornersCustomer,
        props: route => ({ eid: route.params.eid }),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'four-corners/client/:eid',
        name: 'UserFourCornersClient',
        component: UserFourCornersClient,
        props: route => ({ eid: route.params.eid }),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'four-corners/competition/:eid',
        name: 'UserFourCornersCompetition',
        component: UserFourCornersCompetition,
        props: route => ({ eid: route.params.eid }),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'culture',
        name: 'UserCultureMenu',
        component: UserCultureMenu,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'culture/language/:eid',
        name: 'UserCultureLanguage',
        component: UserCultureLanguage,
        props: route => ({ eid: route.params.eid }),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'culture/knowledge/:eid',
        name: 'UserCultureKnowledge',
        component: UserCultureKnowledge,
        props: route => ({ eid: route.params.eid }),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'culture/behaviour/:eid',
        name: 'UserCultureBehaviour',
        component: UserCultureBehaviour,
        props: route => ({ eid: route.params.eid }),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'culture/dynamics/:eid',
        name: 'UserCultureDynamics',
        component: UserCultureDynamics,
        props: route => ({ eid: route.params.eid }),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'museum-of-objects',
        name: 'UserMuseum',
        component: UserMuseum,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'personas',
        name: 'UserPersonasMenu',
        component: UserPersonasMenu,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'personas/:eid',
        name: 'UserPersonasId',
        component: UserPersonas,
        props: route => ({ eid: route.params.eid }),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'personas/create',
        name: 'UserPersonasNew',
        component: UserPersonas,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'groups',
        name: 'UserGroupsMenu',
        component: UserGroupsMenu,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'groups/:eid',
        name: 'UserGroupsId',
        component: UserGroups,
        props: route => ({ eid: route.params.eid }),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'groups/create',
        name: 'UserGroupssNew',
        component: UserGroups,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'activation',
        name: 'UserActivation',
        component: UserActivation,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'travel',
        name: 'UserTravel',
        component: UserTravel,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'swot',
        name: 'UserSwot',
        component: UserSwot,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'traffic',
        name: 'UserTraffic',
        component: UserTraffic,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'problem',
        name: 'UserProblem',
        component: UserProblem,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'deliverables',
        name: 'UserDeliverables',
        component: UserDeliverables,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'deliverables-categories',
        name: 'UserDeliverablesCategorised',
        component: UserDeliverablesCategorised,
        meta: {
          requiresAuth: true
        }
      },

      {
        path: 'deliverables-internal',
        name: 'UserDeliverablesMenu',
        component: UserDeliverablesMenu,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'deliverables-internal/create',
        name: 'UserDeliverablesAmbassadors',
        component: UserDeliverablesAmbassadors,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'deliverables-internal/:eid',
        name: 'UserDeliverablesAmbassadorsId',
        props: route => ({ eid: route.params.eid }),
        component: UserDeliverablesAmbassadors,
        meta: {
          requiresAuth: true
        }
      },

      {
        path: 'empathy',
        name: 'UserEmpathy',
        component: UserEmpathy,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'isinif',
        name: 'UserIsInIf',
        component: UserIsInIf,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'blocks',
        name: 'UserBlock',
        component: UserBlock,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'service',
        name: 'UserService',
        component: UserService,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'service-user',
        name: 'UserServiceUser',
        component: UserServiceUser,
        meta: {
          requiresAuth: true,
          model: 'serviceExCollection',
          content: 'exercise_service_user'
        }
      },
      {
        path: 'proposition',
        name: 'UserProposition',
        component: UserProposition,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'message',
        name: 'UserMessage',
        component: UserMessage,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'fly',
        name: 'UserFly',
        component: UserFly,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'results',
        name: 'UserResults',
        component: UserResults,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'priority',
        name: 'UserPriority',
        component: UserPriority,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'stakeholder',
        name: 'UserStakeholder',
        component: UserStakeholder,
        meta: {
          requiresAuth: true,
          content: 'exercise_stakeholder',
          model: 'stakeholderExCollection'
        }
      },
      {
        path: 'stakeholder-standard',
        name: 'UserStakeholderStandard',
        component: UserStakeholderStandard,
        meta: {
          requiresAuth: true,
          content: 'exercise_stakeholder_standard',
          model: 'stakeholderExCollection'
        }
      },
      {
        path: 'timeline',
        name: 'UserTimeline',
        component: UserTimeline,
        meta: {
          requiresAuth: true,
          content: 'exercise_timeline',
          model: 'timelineExCollection'
        }
      },
      {
        path: 'timeline-ade',
        name: 'UserTimelineAde',
        component: UserTimeline,
        meta: {
          requiresAuth: true,
          content: 'exercise_timeline_themes',
          model: 'timelineADEExCollection'
        }
      },

      {
        path: 'attributes',
        name: 'UserAttributes',
        component: UserAttributes,
        meta: {
          requiresAuth: true,
          content: 'exercise_attributes',
          model: 'attributesPt1ExCollection'
        }
      },
      {
        path: 'attributes-bl',
        name: 'UserAttributesBL',
        component: UserAttributes,
        meta: {
          requiresAuth: true,
          content: 'exercise_attributes',
          model: 'attributesPt1ExCollection'
        }
      },
      {
        path: 'benefits',
        name: 'UserBenefits',
        component: UserBenefits,
        meta: {
          requiresAuth: true,
          content: 'exercise_benefits_brand',
          model: 'attributesPt2ExCollection'
        }
      },
      {
        path: 'benefits-bl',
        name: 'UserBenefitsBl',
        component: UserBenefits,
        meta: {
          requiresAuth: true,
          content: 'exercise_benefits_bl',
          model: 'attributesPt2ExCollection'
        }
      },
      {
        path: 'benefits-uoy',
        name: 'UserBenefitsUoy',
        component: UserBenefits,
        meta: {
          requiresAuth: true,
          content: 'exercise_benefits_uoy',
          model: 'attributesPt2ExCollection'
        }
      },
      {
        path: 'brand-architecture',
        name: 'UserBrandArchitecture',
        component: UserBrandArchitecture,
        meta: {
          requiresAuth: true,
          content: 'exercise_brand_architecture',
          model: 'brandArchitectureExCollection'
        }
      },
      {
        path: 'success',
        name: 'UserSuccess',
        component: UserSuccess,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'challenge-pillars',
        name: 'UserChallengePillars',
        component: UserChallengePillars,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'success-pillars',
        name: 'UserSuccessPillars',
        component: UserSuccessPillars,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'audience',
        name: 'UserQuadrantsAudience',
        component: UserQuadrants,
        meta: {
          requiresAuth: true,
          content: 'exercise_audience',
          model: 'audienceExCollection'
        }
      },
      {
        path: 'competition',
        name: 'UserQuadrantsCompetition',
        component: UserQuadrants,
        meta: {
          requiresAuth: true,
          content: 'exercise_competition',
          model: 'competitionExCollection'
        }
      },
      {
        path: 'competition-detail',
        name: 'UserCompetition',
        component: UserCompetition,
        meta: {
          requiresAuth: true,
          content: 'exercise_competition_heathfield',
          model: 'competitionDetailExCollection'
        }
      },
      {
        path: 'competition-matrix-1',
        name: 'UserCompetitionMatrix',
        component: UserCompetitionMatrix,
        meta: {
          requiresAuth: true,
          content: 'exercise_competition_matrix_1',
          model: 'competitionDetailExCollection',
          shared: true,
          locked: true
        }
      },
      {
        path: 'competition-matrix-2',
        name: 'UserCompetitionMatrix2',
        component: UserCompetitionMatrixPart2,
        meta: {
          requiresAuth: true,
          content: 'exercise_competition_matrix_2',
          model: 'competitionMatrix2ExCollection',
          ref: 'competitionDetailExCollection',
          shared: false,
          locked: false
        }
      },
      {
        path: 'competition-matrix-ug-1',
        name: 'UserCompetitionMatrixUg1',
        component: UserCompetitionMatrix,
        meta: {
          requiresAuth: true,
          content: 'exercise_competition_matrix_unique_group_1',
          model: 'competitionDetailExCollection',
          shared: true,
          locked: false
        }
      },
      {
        path: 'competition-matrix-ug-2',
        name: 'UserCompetitionMatrixUg2',
        component: UserCompetitionMatrixPart2,
        meta: {
          requiresAuth: true,
          content: 'exercise_competition_matrix_unique_group_2',
          model: 'competitionMatrix2ExCollection',
          ref: 'competitionDetailExCollection',
          shared: false,
          locked: false
        }
      },
      {
        path: 'structure',
        name: 'UserStructure',
        component: UserStructure,
        meta: {
          requiresAuth: true
        }
      },

      {
        path: 'naming-structure',
        name: 'UserNameSystemMenu',
        component: UserNameSystemMenu,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'naming-structure/create',
        name: 'UserNameSystemCreate',
        component: UserNameSystemId,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'naming-structure/:eid',
        name: 'UserNameSystemId',
        props: route => ({ eid: route.params.eid }),
        component: UserNameSystemId,
        meta: {
          requiresAuth: true
        }
      },

      {
        path: 'logic-system',
        name: 'UserLogicSystemMenu',
        component: UserLogicSystemMenu,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'logic-system/create',
        name: 'UserLogicSystemCreate',
        component: UserLogicSystemId,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'logic-system/:eid',
        name: 'UserLogicSystemId',
        props: route => ({ eid: route.params.eid }),
        component: UserLogicSystemId,
        meta: {
          requiresAuth: true
        }
      },

      {
        path: 'mapping',
        name: 'UserMappingMenu',
        component: UserMappingMenu,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'mapping/:eid',
        name: 'UserMappingId',
        props: route => ({ eid: route.params.eid }),
        component: UserMappingId,
        meta: {
          requiresAuth: true
        }
      },

      {
        path: 'eco-system',
        name: 'UserEcoSystemMenu',
        component: UserEcoSystemMenu,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'eco-system/:eid',
        name: 'UserEcoSystemId',
        props: route => ({ eid: route.params.eid }),
        component: UserEcoSystemId,
        meta: {
          requiresAuth: true
        }
      },

      {
        path: 'challenges-system',
        name: 'UserChallengesSystemMenu',
        component: UserChallengesSystemMenu,
        meta: {
          requiresAuth: true
        }
      },

      {
        path: 'challenges-system/:eid',
        name: 'UserChallengesSystemId',
        props: route => ({ eid: route.params.eid }),
        component: UserChallengesSystemId,
        meta: {
          requiresAuth: true
        }
      },

      {
        path: 'offer-system',
        name: 'UserOfferSystemMenu',
        component: UserOfferSystemMenu,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'offer-system/:eid',
        name: 'UserOfferSystemId',
        props: route => ({ eid: route.params.eid }),
        component: UserOfferSystemId,
        meta: {
          requiresAuth: true
        }
      },

       {
        path: 'offer-system-v2',
        name: 'UserOfferSystemMenuTabs',
        component: UserOfferSystemMenuTabs,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'offer-system-v2/:eid',
        name: 'UserOfferSystemIdTabs',
        props: route => ({ eid: route.params.eid }),
        component: UserOfferSystemIdTabs,
        meta: {
          requiresAuth: true
        }
      },

       {
        path: 'offer-ecosystem-facilitated',
        name: 'UserOfferSystemFacilitatedMenu',
        component: UserOfferSystemFacilitatedMenu,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'offer-ecosystem-facilitated/:eid',
        name: 'UserOfferSystemFacilitated',
        props: route => ({ eid: route.params.eid }),
        component: UserOfferSystemFacilitated,
        meta: {
          requiresAuth: true
        }
      },

      {
        path: 'roll-out',
        name: 'UserRollOutMenu',
        component: UserRollOutMenu,
        meta: {
          requiresAuth: true
        }
      },

      {
        path: 'roll-out/:eid',
        name: 'UserRollOutId',
        props: route => ({ eid: route.params.eid }),
        component: UserRollOutId,
        meta: {
          requiresAuth: true
        }
      },


      {
        path: 'audience-system',
        name: 'UserAudienceSystemMenu',
        component: UserAudienceSystemMenu,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'audience-system/:eid',
        name: 'UserAudienceSystemId',
        props: route => ({ eid: route.params.eid }),
        component: UserAudienceSystemId,
        meta: {
          requiresAuth: true
        }
      },

      {
        path: 'pictos',
        name: 'UserPictos',
        component: UserPictos,
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: 'edit/:edit',
            name: 'PictosEdit',
            component: PictosEdit,
            props: route => ({ edit: route.params.edit })
          },
          {
            path: 'add',
            name: 'PictosAdd',
            component: PictosAdd
          }
        ]
      }
    ]
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = firebase.auth().currentUser

  if (requiresAuth && !currentUser) {
    next('/login')
  } else if (requiresAuth && currentUser) {
    next()
  } else {
    next()
  }
})

export default router
